module.exports = __webpack_public_path__ + "img/744.a34b9062.jpg";